import { get_headers, get_project_id } from '@/utils/constants/constants';

const OVERVIEW_QUERY_KEYS = ["application_id", "entity_profile_id"];

function read_overview_query_value(query, key) {
  const safe_query = query || {};
  const query_value = Reflect.get(safe_query, key) ?? null;

  return query_value;
}

function did_overview_query_change(new_query, old_query) {
  const did_change = OVERVIEW_QUERY_KEYS.some((key) => {
    const new_value = read_overview_query_value(new_query, key);
    const old_value = read_overview_query_value(old_query, key);

    return new_value !== old_value;
  });

  return did_change;
}

export const entity_application_overview_data = () => ({
  active_master_tab: 'profile',
  active_tab: 'Overview',
  application_status: "",
  requests: [],
  headers: get_headers(),
  visible_tabs: [],
  db_tabs: [],
  all_tabs: [],
  dropdown_options: {},
  application_form_id: null,
  entity_name: sessionStorage.getItem('entity_name'),
  show_edit_entity_modal: false,
  current_edit_entity: {
    first_name: '',
    last_name: ''
  },
  openSections: {
    onboarding: true,
    documents: false,
    compliance: false
  },
  child_entity_tab_map: {},
  child_tabs: [],
  current_entity: null,
  current_form: {
    parent_id: null,
    parent_name: '',
    child_id: '',
    parent_application_id: '',
    parent_entity_profile_id: '',
  },
  assign_sub_entity_type_id: '',
  assign_sub_entity_options: [],
  assign_form_list: [],
  assign_selected_form_id: '',
  assign_entity_name: '',
  assign_email: '',
  include_email: false,
  validation_error: null,
  is_loading_options: false,
  is_saving: false,
  project_id: null,
  share_child_entity_type_id: '',
  share_child_entity_type_name: '',
  share_sub_entity_link: '',
  share_sub_entity_error: '',
  is_generating_share_link: false,
});

export const entity_application_overview_watch = {
  '$route.query': {
    deep: true,
    async handler(new_query, old_query) {
      if (!did_overview_query_change(new_query, old_query)) {
        return;
      }

      await this.reload_component_data();
    }
  }
};

export const entity_application_overview_computed = {
  application_id() {
    return this.get_id_from_route_or_storage('application_id');
  },
  entity_profile_id() {
    return this.get_id_from_route_or_storage('entity_profile_id');
  },
  viewed_user_id() {
    return this.get_id_from_route_or_storage('user_id');
  },
  entity_type_id() {
    return this.get_id_from_route_or_storage('entity_type_id');
  },
  profile_role_form_id() {
    return this.get_id_from_route_or_storage('profile_role_form_id');
  },
  status_from_route() {
    return sessionStorage.getItem('application_status') || "";
  },
  filtered_sub_tabs() {
    if (this.active_master_tab !== 'profile') {
      return [];
    }

    return this.visible_tabs.filter(tab =>
      !tab.label.toLowerCase().includes('compliance') &&
      !['Documents', 'Compliance'].includes(tab.id)
    );
  },
  content_type() {
    if (this.is_db_main_section_tab(this.active_tab)) {
      return 'dynamic';
    }

    const static_tabs = ['Overview', 'Verification', 'Requests', 'Documents', 'E-Signing', 'Invoices', 'Compliance'];
    return static_tabs.includes(this.active_tab) ? this.active_tab : 'none';
  },
  has_parent_context() {
    return Boolean(this.$route?.query?.parent_application_id && this.$route?.query?.parent_entity_profile_id);
  },
  parent_entity_name() {
    return this.$route?.query?.parent_entity_name || 'Parent Entity';
  },
};

export function entity_application_overview_mounted() {
  const handle_error = (error) =>
    this.show_error?.(error?.message || 'Failed to load entity overview');

  Promise.resolve()
    .then(() => {
      this.project_id = this.resolve_project_id();
      return this.initialize_overview_data();
    })
    .catch(handle_error);

  this.get_application_status();
}

export function resolve_entity_overview_project_id(vm) {
  return (
    vm.project_id ||
    get_project_id() ||
    vm.$route.params.project_id ||
    vm.$route.query.project_id ||
    sessionStorage.getItem('project_id') ||
    null
  );
}
